<template>
  <b-modal
    ref="modal"
    :title="$t(isUpdate ? 'label.domain_update' : 'label.domain_add')"
    scrollable
    hide-footer>
    <b-form @submit.prevent="onSubmit">
      <b-form-group
        :label="$t('label.domain_name')"
        label-for="set-domain-label-input">
        <b-form-input
          id="set-domain-label-input"
          v-model="domain.dac_label"
          type="text"
          :disabled="loading"
          :placeholder="$t('label.domain_add_placeholder')"
          required>
        </b-form-input>
      </b-form-group>
      <b-form-group
        :label="$t('label.domain_color')"
        label-for="set-domain-color-input">
        <b-form-input
          id="set-domain-color-input"
          v-model="domain.dac_data.display.color"
          type="color"
          :disabled="loading">
        </b-form-input>
      </b-form-group>
      <b-form-checkbox
        v-if="isUpdate"
        id="set-domain-is-enable-input"
        v-model="domain.dac_is_enable"
        :value="true"
        :unchecked-value="false"
        :disabled="loading">
        {{ $t('label.active') }}
      </b-form-checkbox>

      <div class="text-center">
        <b-button type="submit" variant="primary" :disabled="loading">
          {{ $t(isUpdate ? 'btn.validate' : 'btn.add_domain') }}
        </b-button>
      </div>

      <b-alert :show="error !== null" variant="danger" class="mt-3">
        {{ error }}
      </b-alert>
    </b-form>
  </b-modal>
</template>

<script>
import { normalizeString } from '../misc/utils';

const DEFAULT_DOMAIN_TEMPLATE = {
  dac_id: null,
  dac_label: "",
  dac_data: {
    display: {
      color: "#cacaca"
    },
  },
  dac_is_enable: true,
}

export default {
  props: {
    domains: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: null,

      domain: { ...DEFAULT_DOMAIN_TEMPLATE },
    };
  },
  computed: {
    isUpdate() {
      return this.domain.dac_id !== null;
    },
  },
  methods: {
    show(originalDomain = null) {
      this.domain = {
        ...DEFAULT_DOMAIN_TEMPLATE,
        ...originalDomain,

        dac_data: {
          ...originalDomain?.dac_data,

          display: {
            ...originalDomain?.dac_data?.display,
            
            color: originalDomain?.dac_data?.display?.color ?? DEFAULT_DOMAIN_TEMPLATE.dac_data.display.color,
          }
        },
      };
      this.error = null;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onSubmit() {
      this.error = null;
      const normalizedName = normalizeString(this.domain.dac_label);
      const existingDomain = this.domains.find(domain => (
        domain.dac_id !== this.domain?.dac_id
        && normalizeString(domain?.dac_label) === normalizedName
      ));

      if (existingDomain !== undefined) {
        this.error = `${this.$t('label.domain_already_exists')} : "${existingDomain.dac_label}"`;
        return;
      }

      this.$emit('onSubmit', this.domain);
    },
  },
};
</script>
